import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const AssociateDegreeIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>{educationLevels().level5.label}</title>
      <path
        d="M125.6,1000.4h554.5l0,0c0.2,0,0.3,0,0.5,0l9.6-0.4c68.3-0.4,123.9-56.5,123.9-125.1V213.5h173.8c6.9,0,12.5-5.6,12.5-12.5
		v-92.5c0-59.6-48.4-108.1-107.8-108.1l-1.6,0c0,0,0,0,0,0c0,0,0,0,0,0L199.5,0.8C131.2,1.2,75.6,57.3,75.6,125.8V753H12.9
		c-6.9,0-12.5,5.6-12.5,12.5v109.4C0.4,944.1,56.6,1000.4,125.6,1000.4z M975.4,108.5v80H814.2v-86.3c0-42.4,34.5-76.8,76.8-76.8
		l1.7,0C938.3,25.4,975.4,62.7,975.4,108.5z M100.6,125.8c0-54.8,44.4-99.7,99-100.1l624.7-0.3c-21.5,18.7-35.2,46.1-35.2,76.8V875
		c0,54.8-44.4,99.7-99.5,100.1l-9.7,0.3C624.8,975.3,580,930.3,580,874.9V765.5c0-6.9-5.6-12.5-12.5-12.5H100.6V125.8z M25.4,778
		H555v96.9c0,41.1,19.8,77.6,50.3,100.5H125.6c-55.2,0-100.2-45.1-100.2-100.5V778z"
      />
      <path
        d="M589.3,606.6c3.4-2.5,5.4-6.5,5.1-10.8l-7.1-134.4l85-104.6c2.7-3.3,3.5-7.7,2.2-11.7s-4.6-7.1-8.7-8.2l-130.5-34.8
		l-73.6-112.9c-4.6-7.1-16.3-7.1-20.9,0l-73.6,112.9l-130.5,34.8c-4.1,1.1-7.4,4.2-8.7,8.2s-0.5,8.5,2.2,11.7l85,104.6l-7.1,134.4
		c-0.2,4.2,1.7,8.3,5.1,10.8c2.2,1.6,4.7,2.4,7.3,2.4c1.5,0,3-0.3,4.5-0.8l126.2-48.3l126.2,48.3
		C581.5,609.7,585.9,609.1,589.3,606.6z M455.8,534.9c-1.4-0.5-3-0.8-4.5-0.8s-3,0.3-4.5,0.8L334.2,578l6.3-120
		c0.2-3.1-0.8-6.1-2.8-8.5l-75.9-93.3L378.3,325c3-0.8,5.6-2.7,7.3-5.3l65.7-100.9L517,319.7c1.7,2.6,4.3,4.5,7.3,5.3l116.5,31.1
		l-75.9,93.3c-2,2.4-2.9,5.5-2.8,8.5l6.3,120L455.8,534.9z"
      />
    </svg>
  );
};

export default AssociateDegreeIcon;

AssociateDegreeIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
